export default __webpack_public_path__ + "static/media/04.a23838d6.jpg";